import * as React from 'react';

import swishHorizontal from './assets/atom-logo-swish-horizontal.png';

interface Props {
    width?: number;
    height?: number;
}

export const PaymentSwish: React.SFC<Props> = ({width, height}) => {

    return (
        <img src={swishHorizontal} width={width} height={height} alt='' />
    );
};
